module.exports = __webpack_public_path__ + "img/1558348069.66d41ec0.jpg";